import React, { Component } from 'react';
import Header from './Header/Header'
import { Switch, Route , Link} from 'react-router-dom'
import ProposalForm from '../../Forms/ProposalForm/ProposalForm'
class GrowthPartnership extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    render() {
        return (
            <div>
            <Header/>
            <section className="ovrfl">
                <div className="container flash_con_pad">
                    <div className="row breadcrumb text-center trght">
                        <div className="col-md-12"> <a href="/"><span>Home</span></a> <i className="fa fa-angle-right"></i> <span>Growth Partnership </span> </div>
                    </div>
                    <div className="row flash_pad flash_pad_res">
                        <div className="panel-body">
                            <div className="col-md-8 custo_bg">
                                <p>
                                    We provide holistic solutions for your business problems, derive actionable insights, and help you achieve your goals. MI’s multidisciplinary teams with years of experience in the science of business and market research, provide high-end insights for establishing the most appropriate strategies for your business growth.
                                </p>

                                <h4>What we do</h4>

                                <p className="hp">We provide high-end strategic and analytical solutions such as: </p>

                                <ul className="growth-ul">
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Production-Revenue Maximization</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp;Business Funding</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Workforce Management</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Branding Analysis</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Raw-material and supply side analysis</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Human Resource Management </li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Supply-Chain Optimization</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Marketing Management</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Competitive Advantage Analysis</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Identifying Potential Clients</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Market Entry</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Market Expansion and Penetration</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Country-Risk Analysis</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Market Structure Analysis</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Player Profiling</li>
                                    <li className="col-md-6"> <i className="fa fa-chevron-right"></i> &nbsp;&nbsp;&nbsp; Regulation &amp; Policy Analysis &amp; Impact</li>
                                </ul>

                            </div>
                           <ProposalForm/>
                        </div>
                    </div>

                    <div className="row pdetails">
                        <div className="col-md-10 col-md-push-1 ">
                            <div className="row text-center">
                                <p className="about">Are you facing issues for finding the right raw-material suppliers for your business? </p>
                                <p className="about">Or your workforce is showing a declining productivity with expansion?  </p>
                                <p className="about">Or targeting to expand your business to a new region where you need partners? </p>
                                <p className="find">Find out how we can help. </p>

                                <Link to="/contact-us" className="btn btn-primary contactus" role="button">contact us</Link>
                            </div>

                        </div>

                    </div>


                </div>
            </section>
            </div>

        );
    }


}
export default GrowthPartnership;


// WEBPACK FOOTER //
// ./src/consulting/GrowthPatnership/GrowthPatnership.js